export default __webpack_public_path__ + "assets/images/bdffb7719a388bfb2ae140eba74f2e83.jpg";